<template>
  <div class="bg-pink">
    <div class="position-relative">
      <header class="heading mb-3">
        <img src="@img/img_logo.png" alt="logo" class="logo" />
        <img src="@img/index/heading1.png" class="heading-img" />
      </header>
      <section class="main-img">
        <img src="@img/index/p1_line.png" class="img-line" />
        <img src="@img/index/p1_kv_img.png" class="img-kv" />
      </section>
      <section class="bottom-bg">
        <div class="btn-wrap">
          <a
            class="btn-go-buy"
            href="https://mall.sfworldwide.com/tdhb_cnygift?utm_source=TDHB&utm_medium=TDHBCNY&utm_campaign=CNY"
            target="_blank"
            rel="noreferrer noopener"
            @click="onClick('go_to_buy')"
          >
            <img
              src="@img/index/p1_btn_buy.png"
              class="btn-img"
              alt="btn-buy"
            />
          </a>
          <router-link to="/select" @click.native="onClick('write_msg')">
            <img src="@img/index/p1_btn_go.png" class="btn-img" alt="btn-go" />
          </router-link>
        </div>
        <div class="description">
          <img src="@img/index/p1_word.png" class="w-100" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import gtagAPI from '../apis/gtag.js'

export default {
  name: 'Index',
  mounted() {
    this.preLoadAll()
  },
  methods: {
    onClick(label) {
      gtagAPI.sendClickEvent(label)
    },
    /** preLoad images of Select page. */
    preLoadAll() {
      const image = require.context('@img/select', false, /(\.png|\.jpg)$/)

      image.keys().forEach((path) => {
        const img = new Image()
        img.src = image(path)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.heading {
  position: relative;
  z-index: 1;

  .logo {
    width: 15%;
    margin-left: 5%;
    position: absolute;
    top: 0;
  }

  .heading-img {
    width: 100%;
  }
}

.main-img {
  position: relative;
  z-index: 2;
  margin-top: -21%;

  .img-line {
    width: 100%;
    padding-top: 22%;
  }

  .img-kv {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.bottom-bg {
  position: relative;
  z-index: 1;
  background: url('~@img/index/p1_bottom.png') no-repeat;
  background-size: 100%;
  background-position-y: bottom;
  margin-top: 0;
  padding-top: 8%;

  .btn-wrap {
    display: flex;
    flex-flow: nowrap;
    align-items: center;
    text-align: center;
    padding-left: 5%;
    padding-right: 3%;
  }

  .btn-go-buy {
    margin-right: 5%;
  }

  .btn-img {
    width: 100%;
  }

  .description {
    padding: 0 2%;
    padding-bottom: 17%;
  }
}
</style>
